<script setup>
import { onMounted, ref, computed } from "vue";
import { onClickOutside } from "@vueuse/core";

const props = defineProps({
  options: Array,
  hasError: Boolean,
});

const allSelected = ref(false);

const outer = ref(null);

const emit = defineEmits(["valueChange"]);

onMounted(() => {
  // console.log("INCOMING DATA", tmpOptions.value);
  if (
    tmpOptions.value.every((element) => {
      return element.selected === true;
    })
  ) {
    allSelected.value = true;
  }
});

const tmpOptions = ref(props.options);

function selectAll() {
  allSelected.value = !allSelected.value;

  tmpOptions.value.forEach((option) => {
    option.selected = allSelected.value;
  });

  // close the dropdown
  isOpen.value = false;

  emit(
    "valueChange",
    tmpOptions.value.filter((s) => s.selected).map((s) => s.value)
  );
}

function changeValue(selection) {
  selection.selected = !selection.selected;
  if (selection.selected) {
    if (
      tmpOptions.value.every((element) => {
        return element.selected === true;
      })
    ) {
      allSelected.value = true;
    }
  } else {
    allSelected.value = false;
  }

  emit(
    "valueChange",
    tmpOptions.value.filter((s) => s.selected).map((s) => s.value)
  );
}

const isOpen = ref(false);

onClickOutside(outer, () => {
  isOpen.value = false;
});
</script>

<template>
  <div :ref="'outer'" class="shadow-sm relative">
    <div
      @click="isOpen = !isOpen"
      class="rounded-md px-3 py-2 text-oteoText bg-oteoInputBG border-none background-pos relative flex items-center"
      :class="{
        'rounded-b-none': isOpen,
        'bg-red-100': hasError,
      }"
    >
      <span class="text-ellipsis">
        {{
          allSelected
            ? "Alle"
            : tmpOptions
                .filter((s) => s.selected)
                .map(function (elem) {
                  return elem.label;
                })
                .join(", ")
                .substring(0, 30) || "Bitte auswählen"
        }}
      </span>

      <span
        class="absolute right-2 w-6 h-6 transition-transform"
        :class="{ 'rotate-180': isOpen }"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
          <path
            stroke="#6b7280"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M6 8l4 4 4-4"
          />
        </svg>
      </span>
    </div>
    <ul
      v-if="isOpen"
      class="bg-oteoInputBG rounded-b-md flex flex-col absolute left-0 right-0 shadow-sm text-s z-50"
    >
      <label class="flex items-center my-1 px-2">
        <input
          :checked="allSelected"
          @change="selectAll()"
          type="checkbox"
          class="mr-2"
        />
        Alle
      </label>
      <label
        v-for="selection in tmpOptions"
        :key="selection.value"
        :value="selection.value"
        class="flex items-center my-1 px-2"
      >
        <input
          :checked="selection.selected"
          @change="changeValue(selection)"
          type="checkbox"
          class="mr-2"
          :id="'s' + selection.value"
        />

        {{ selection.text }}
        <label
          :for="'s' + selection.value"
          class="ml-auto px-0.5 text-slotBadgeBorder border border-slotBadgeBorder rounded"
        >
          {{ selection.label }}
        </label>
      </label>
    </ul>
  </div>
</template>
